import { render } from "./DropdownAutocompleteSingleSelect.vue?vue&type=template&id=243cd475&ts=true"
import script from "./DropdownAutocompleteSingleSelect.vue?vue&type=script&lang=ts"
export * from "./DropdownAutocompleteSingleSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__